import { render, staticRenderFns } from "./huanbao.vue?vue&type=template&id=069f98d0&scoped=true&"
import script from "./huanbao.vue?vue&type=script&lang=js&"
export * from "./huanbao.vue?vue&type=script&lang=js&"
import style0 from "./huanbao.vue?vue&type=style&index=0&id=069f98d0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069f98d0",
  null
  
)

export default component.exports